import { useDisclosure } from "@mantine/hooks";
import { BuyButton } from "@src/components/plan/buy-button";
import { useActivateStarter } from "@src/components/plan/mutations/activate-starter";
import { TrialDowngradeWarningModal } from "../trial-downgrade-warning-modal";
import {
	PlanCard,
	PlanCta,
	PlanDescription,
	PlanLabelBadge,
	PlanPrice,
	PlanSecondaryButton,
} from "./plan-modal-card-ui";

export function FreePlanCard(props: {
	isPlanActive: boolean;
	isButtonDisabled: boolean;
	isDowngrade: boolean;
	isInTrial: boolean;
	isTrialEnded: boolean;
	proCheckoutPriceId?: string | null;
	label: string;
	showCta?: boolean;
	onDowngradeSuccess?: () => void;
}) {
	const {
		isPlanActive,
		isButtonDisabled = false,
		isDowngrade,
		isInTrial,
		isTrialEnded,
		proCheckoutPriceId,
		label,
		showCta = true,
		onDowngradeSuccess,
	} = props;

	const { mutate: activateStarter, isPending } = useActivateStarter();

	const [warningOpened, { open: openWarning, close: closeWarning }] =
		useDisclosure(false);

	const buttonIsDisabled = isPlanActive || isButtonDisabled || isPending;

	function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		if (isDowngrade) {
			openWarning();
		} else {
			activateStarter();
		}
	}

	const modalVariant = isTrialEnded
		? "trial-ended"
		: isInTrial
			? "in-trial"
			: "pro-active";

	return (
		<>
			<TrialDowngradeWarningModal
				opened={warningOpened}
				onClose={closeWarning}
				onDowngradeSuccess={onDowngradeSuccess}
				variant={modalVariant}
				proCheckoutPriceId={proCheckoutPriceId}
			/>

			<PlanCard active={isPlanActive}>
				<PlanLabelBadge variant="default">Starter</PlanLabelBadge>

				<PlanPrice price="Free" period="monthly" />

				<PlanDescription>
					<p>
						Ideas arrive in fragments. Capture them as cards, bring AI in where
						you need it, and build from there. Nothing gets lost between
						sessions.
					</p>
				</PlanDescription>

				{showCta && (
					<PlanCta>
						<PlanSecondaryButton>
							<BuyButton
								variant="default"
								disabled={buttonIsDisabled}
								onClick={handleClick}
							>
								{isPending ? "Activating..." : label}
							</BuyButton>
						</PlanSecondaryButton>
					</PlanCta>
				)}
			</PlanCard>
		</>
	);
}
